/* eslint-disable new-cap, no-invalid-this, react/prop-types */
import React from 'react';
import {Editor} from 'slate-react';
import {Value} from 'slate';
import {
  DataProviderPlugin
} from './plugins';
// import ExerciseLayoutContainer from './tupperware/ExerciseLayoutContainer.res.mjs';
// import DropDownOptionContainer from './tupperware/DropDownOptionContainer.res.mjs';
// import DropDownContainer from './tupperware/DropDownContainer.res.mjs';
// import ClozeDropTextContainer from './tupperware/ClozeDropTextContainer.res.mjs';
// import ClozeDragTextContainer from './tupperware/ClozeDragTextContainer.res.mjs';
// import ClozeChoiceProvider from './tupperware/ClozeChoiceProvider.res.mjs';
// import MultiChoiceOptionContainer from './tupperware/MultiChoiceOptionContainer.res.mjs';
// import MultiChoiceGroupedOptionContainer from './tupperware/MultiChoiceGroupedOptionContainer.res.mjs';
// import NonMarkingQuestion from './tupperware/NonMarkingQuestion.res.mjs';
import BlockStyleClassName from './tupperware/BlockStyleClassName.res.mjs';
import InlineStyleClassName from './tupperware/InlineStyleClassName.res.mjs';
// import MultiChoiceOptionStatesContainer from './tupperware/MultiChoiceOptionStatesContainer.res.mjs';
import ShuffleChildren from './tupperware/ShuffleChildren';
// import TextInputContainer from './tupperware/TextInputContainer.res.mjs';
// import ShowAnswerWrapper from './tupperware/ShowAnswerWrapper.res.mjs';
// import SideDrawer from './tupperware/SideDrawer.res.mjs';
// import ShowContent from './tupperware/ShowContent.res.mjs';
import SkilfulLayoutContainer from './tupperware/v2/SkilfulLayoutContainer.res.mjs';
import PieceOfCakeLayoutContainer from './tupperware/v2/PieceOfCakeLayoutContainer.res.mjs';
import SkilfulQuestionVisible from './tupperware/v2/SkilfulQuestionVisible.res.mjs';
import PieceOfCakeQuestionVisible from './tupperware/v2/PieceOfCakeQuestionVisible.res.mjs';
import SkilfulMultiChoiceContainer from './tupperware/v2/SkilfulMultiChoiceContainer.res.mjs';
import PieceOfCakeMultiChoiceContainer from './tupperware/v2/PieceOfCakeMultiChoiceContainer.res.mjs';
import SkilfulMultiChoiceSingleResponseContainer from './tupperware/v2/SkilfulMultiChoiceSingleResponseContainer.res.mjs';
import PieceOfCakeMultiChoiceSingleResponseContainer from './tupperware/v2/PieceOfCakeMultiChoiceSingleResponseContainer.res.mjs';
import SkilfulMultiChoiceMultiResponseContainer from './tupperware/v2/SkilfulMultiChoiceMultiResponseContainer.res.mjs';
import PieceOfCakeMultiChoiceMultiResponseContainer from './tupperware/v2/PieceOfCakeMultiChoiceMultiResponseContainer.res.mjs';
import K2BookQuestions from './tupperware/v2/K2BookQuestions.res.mjs';
import K2Answers from './tupperware/v2/K2Answers.res.mjs';
import SkilfulStemHeading from './tupperware/v2/SkilfulStemHeading.res.mjs';
import StemHeading from './tupperware/v2/StemHeading.res.mjs';
import ImageSoundQuestion from './tupperware/v2/ImageSoundQuestion.res.mjs';
import AnswerBox from './tupperware/v2/AnswerBox.res.mjs';
import AnswerBoxMed from './tupperware/v2/AnswerBoxMed.res.mjs';
import AudioQuestionContainer from './tupperware/v2/AudioQuestionContainer.res.mjs';
import AnswerBoxSlim from './tupperware/v2/AnswerBoxSlim.res.mjs';
import SkilfulRadioButtonMultiChoice from './tupperware/v2/SkilfulRadioButtonMultiChoice.res.mjs';
import SkilfulCheckboxButtonMultiChoice from './tupperware/v2/SkilfulCheckboxButtonMultiChoice.res.mjs';
import SkilfulContent from './tupperware/v2/SkilfulContent.res.mjs';
import SkilfulTextInputContainer from './tupperware/v2/SkilfulTextInputContainer.res.mjs';
import SkilfulDropDownOptionContainer from './tupperware/v2/SkilfulDropDownOptionContainer.res.mjs';
import SkilfulClozeDropTextContainer from './tupperware/v2/SkilfulClozeDropTextContainer.res.mjs';
import SkilfulClozeDragTextContainer from './tupperware/v2/SkilfulClozeDragTextContainer.res.mjs';
import V2ClozeChoiceProvider from './tupperware/v2/V2ClozeChoiceProvider.res.mjs';
import SkilfulClozeDropBucketContainer from './tupperware/v3/SkilfulClozeDropBucketContainer.res.mjs';
import SkilfulClozeDragBucketContainer from './tupperware/v3/SkilfulClozeDragBucketContainer.res.mjs';
import SkilfulClozeDragBucketDisplay from './tupperware/v3/SkilfulClozeDragBucketDisplay.res.mjs';
import SkilfulClozeDropBucketDisplay from './tupperware/v3/SkilfulClozeDropBucketDisplay.res.mjs';
import SkilfulClozeBucketProvider from './tupperware/v3/SkilfulClozeBucketProvider.res.mjs';
import SkilfulDragPanelSticky from './tupperware/v2/SkilfulDragPanelSticky.res.mjs';
import SkilfulStimulusContainer from './tupperware/v2/SkilfulStimulusContainer.res.mjs';
import SkilfulQuestionContent from './tupperware/v2/SkilfulQuestionContent.res.mjs';
import SkilfulStimulusTabContent from './tupperware/v2/SkilfulStimulusTabContent.res.mjs';
import SkilfulHighlightProvider from './tupperware/v2/SkilfulHighlightProvider.res.mjs';
import SkilfulHighlightBucket from './tupperware/v2/SkilfulHighlightBucket.res.mjs';
import SkilfulHighlightClickToAddToBucket from './tupperware/v2/SkilfulHighlightClickToAddToBucket.res.mjs';
import CustomTable from './tupperware/v3/V3CustomTable.res.mjs';
import CustomTableRow from './tupperware/v3/V3CustomTableRow.res.mjs';
import CustomTableCell from './tupperware/v3/V3CustomTableCell.res.mjs';
import V3Portal from './tupperware/v3/V3Portal.res.mjs';
import V3AdvancedLayout from './tupperware/v3/V3AdvancedLayout.res.mjs';
import V3Tooltip from './tupperware/v3/V3Tooltip.res.mjs';
import SkilfulPunctuation from './tupperware/v3/SkilfulPunctuation.res.mjs';
import V3Video from './tupperware/v3/V3Video.res.mjs';

// const MC = require('./tupperware/MC.res.mjs');
// const GroupedMcCheckBoxBucketButton = require('./tupperware/Bucket.res.mjs').Button.make;
// const GroupedMcCheckBoxBucketProvider = require('./tupperware/Bucket.res.mjs').Provider.make;
// const GroupedMcCheckbox = require('./tupperware/GroupedMcCheckbox.res.mjs').make;

const plugins = [
  // DataProviderPlugin(ExerciseLayoutContainer, 'ExerciseLayoutContainer'),
  // DataProviderPlugin(DropDownOptionContainer, 'DropDownOptionContainer'),
  // DataProviderPlugin(DropDownContainer, 'DropDownContainer'),
  // DataProviderPlugin(ClozeDropTextContainer, 'ClozeDropTextContainer'),
  // DataProviderPlugin(ClozeChoiceProvider, 'ClozeChoiceProvider'),
  // DataProviderPlugin(ClozeDragTextContainer, 'ClozeDragTextContainer'),
  // DataProviderPlugin(MultiChoiceOptionContainer, 'MultiChoiceOptionContainer'),
  // DataProviderPlugin(MultiChoiceGroupedOptionContainer, 'MultiChoiceGroupedOptionContainer'),
  // DataProviderPlugin(NonMarkingQuestion, 'NonMarkingQuestion'),
  DataProviderPlugin(BlockStyleClassName, 'BlockStyleClassName'),
  DataProviderPlugin(InlineStyleClassName, 'InlineStyleClassName'),
  // DataProviderPlugin(MultiChoiceOptionStatesContainer, 'MultiChoiceOptionStatesContainer'),
  // DataProviderPlugin(MC.exactResponseRequiredComponent, 'MC.ExactResponseRequired'),
  // DataProviderPlugin(MC.responseRequiredComponent, 'MC.ResponseRequired'),
  // DataProviderPlugin(MC.singleResponseComponenet, 'MC.SingleResponse'),
  // DataProviderPlugin(MC.multipleResponseComponent, 'MC.MultipleResponse'),
  // DataProviderPlugin(TextInputContainer, 'TextInputContainer'),
  DataProviderPlugin(ShuffleChildren, 'ShuffleChildren'),
  // DataProviderPlugin(ShowAnswerWrapper, 'ShowAnswerWrapper'),
  // DataProviderPlugin(SideDrawer, 'SideDrawer'),
  // DataProviderPlugin(ShowContent, 'ShowContent'),
  // DataProviderPlugin(GroupedMcCheckBoxBucketButton, 'GroupedMcCheckbox.SetGroupButton'),
  // DataProviderPlugin(GroupedMcCheckBoxBucketProvider, 'GroupedMcCheckbox.GroupProvider'),
  // DataProviderPlugin(GroupedMcCheckbox, 'GroupedMcCheckbox.ClickToAddToGroupAndHighlight'),
  DataProviderPlugin(SkilfulLayoutContainer, 'SkilfulLayoutContainer'),
  DataProviderPlugin(PieceOfCakeLayoutContainer, 'PieceOfCakeLayoutContainer'),
  DataProviderPlugin(SkilfulQuestionVisible, 'SkilfulQuestionVisible'),
  DataProviderPlugin(PieceOfCakeQuestionVisible, 'PieceOfCakeQuestionVisible'),
  DataProviderPlugin(SkilfulMultiChoiceContainer, 'SkilfulMultiChoiceContainer'),
  DataProviderPlugin(PieceOfCakeMultiChoiceContainer, 'PieceOfCakeMultiChoiceContainer'),
  DataProviderPlugin(SkilfulMultiChoiceSingleResponseContainer, 'SkilfulMultiChoiceSingleResponseContainer'),
  DataProviderPlugin(PieceOfCakeMultiChoiceSingleResponseContainer, 'PieceOfCakeMultiChoiceSingleResponseContainer'),
  DataProviderPlugin(SkilfulMultiChoiceMultiResponseContainer, 'SkilfulMultiChoiceMultiResponseContainer'),
  DataProviderPlugin(PieceOfCakeMultiChoiceMultiResponseContainer, 'PieceOfCakeMultiChoiceMultiResponseContainer'),
  DataProviderPlugin(K2BookQuestions, 'K2BookQuestions'),
  DataProviderPlugin(K2Answers, 'K2Answers'),
  DataProviderPlugin(SkilfulStemHeading, 'SkilfulStemHeading'),
  DataProviderPlugin(StemHeading, 'StemHeading'),
  DataProviderPlugin(ImageSoundQuestion, 'ImageSoundQuestion'),
  DataProviderPlugin(AnswerBox, 'AnswerBox'),
  DataProviderPlugin(AnswerBoxMed, 'AnswerBoxMed'),
  DataProviderPlugin(AnswerBoxSlim, 'AnswerBoxSlim'),
  DataProviderPlugin(AudioQuestionContainer, 'AudioQuestionContainer'),
  DataProviderPlugin(SkilfulRadioButtonMultiChoice, 'SkilfulRadioButtonMultiChoice'),
  DataProviderPlugin(SkilfulRadioButtonMultiChoice, 'V3MultiChoice'),
  DataProviderPlugin(SkilfulCheckboxButtonMultiChoice, 'SkilfulCheckboxButtonMultiChoice'),
  DataProviderPlugin(SkilfulContent, 'SkilfulContent'),
  DataProviderPlugin(SkilfulTextInputContainer, 'SkilfulTextInputContainer'),
  DataProviderPlugin(SkilfulDropDownOptionContainer, 'SkilfulDropDownOptionContainer'),
  DataProviderPlugin(SkilfulClozeDropTextContainer, 'SkilfulClozeDropTextContainer'),
  DataProviderPlugin(SkilfulClozeDragTextContainer, 'SkilfulClozeDragTextContainer'),
  DataProviderPlugin(V2ClozeChoiceProvider, 'V2ClozeChoiceProvider'),
  DataProviderPlugin(SkilfulClozeDropBucketContainer, 'SkilfulClozeDropBucketContainer'),
  DataProviderPlugin(SkilfulClozeDragBucketContainer, 'SkilfulClozeDragBucketContainer'),
  DataProviderPlugin(SkilfulClozeDragBucketDisplay, 'SkilfulClozeDragBucketDisplay'),
  DataProviderPlugin(SkilfulClozeDropBucketDisplay, 'SkilfulClozeDropBucketDisplay'),
  DataProviderPlugin(SkilfulClozeBucketProvider, 'SkilfulClozeBucketProvider'),
  DataProviderPlugin(SkilfulDragPanelSticky, 'SkilfulDragPanelSticky'),
  DataProviderPlugin(SkilfulStimulusContainer, 'SkilfulStimulusContainer'),
  DataProviderPlugin(SkilfulQuestionContent, 'SkilfulQuestionContent'),
  DataProviderPlugin(SkilfulStimulusTabContent, 'SkilfulStimulusTabContent'),
  DataProviderPlugin(SkilfulHighlightProvider, 'SkilfulHighlightProvider'),
  DataProviderPlugin(SkilfulHighlightBucket, 'SkilfulHighlightBucket'),
  DataProviderPlugin(SkilfulHighlightClickToAddToBucket, 'SkilfulHighlightClickToAddToBucket'),
  DataProviderPlugin(CustomTable, "custom_table"),
  DataProviderPlugin(CustomTableRow, "custom_table_row"),
  DataProviderPlugin(CustomTableCell, "custom_table_cell"),
  DataProviderPlugin(V3AdvancedLayout, "V3AdvancedLayout"),
  DataProviderPlugin(V3Portal, "V3Portal"),
  DataProviderPlugin(V3Tooltip, "V3Tooltip"),
  DataProviderPlugin(SkilfulPunctuation, "SkilfulPunctuation"),
  DataProviderPlugin(V3Video, "V3Video"),
];

class ActivityContainer extends React.Component {
  state = {
    value: Value.fromJSON(JSON.parse(this.props.data))
  }
  onChange = ({value}) => {
    this.setState({value});
  }

  shouldComponentUpdate = (nextProps) => {
    return nextProps.data !== this.props.data;
  }

  renderNode = (props, editor, next) => {
    const {attributes, children, node} = props;
    let data;

    switch (node.type) {
      case 'image':
        return <img src={node.data.get('src')} {...attributes} />;
      case 'block-quote':
        return <blockquote {...attributes}>{children}</blockquote>;
      case 'bulleted-list':
        return <ul {...attributes}>{children}</ul>;
      case 'heading-one':
        data = node.data.toJS();
        return <h1 className={data.className} {...attributes}>{children}</h1>;
      case 'heading-two':
        data = node.data.toJS();
        return <h2 className={data.className} {...attributes}>{children}</h2>;
      case 'list-item':
        return <li {...attributes}>{children}</li>;
      case 'numbered-list':
        return <ol {...attributes}>{children}</ol>;
      case 'alignment':
        data = node.data.toJS();
        return <div {...attributes} style={{textAlign: data.align}}>{children}</div>;
      // case 'custom_table':
      //   data = node.data.toJS();
      //   return <CustomTable tableTemplate={data.tableTemplate} {...attributes}>{children}</CustomTable>;
      // case 'custom_table_row':
      //   return <CustomTableRow {...attributes}>{children}</CustomTableRow>;
      // case 'custom_table_cell':
      //   return <CustomTableCell {...attributes}>{children}</CustomTableCell>;
      case 'table':
        return <Table {...props} />;
      case 'table_row':
        return <TableRow {...props} />;
      case 'table_cell':
        return <TableCell {...props} />;
      case 'paragraph':
        return <p {...attributes}>{children}</p>;
    }

    return next();
  }

  renderMark = (props, editor, next) => {
    const {children, mark, attributes} = props;

    switch (mark.type) {
      case 'bold':
        return <strong {...attributes}>{children}</strong>;
      case 'code':
        return <code {...attributes}>{children}</code>;
      case 'italic':
        return <em {...attributes}>{children}</em>;
      case 'underlined':
        return <u {...attributes}>{children}</u>;
    }

    return next();
  }

  render() {
    return (
      <div>
        {this.renderEditor()}
      </div>
    );
  }
  renderEditor = () => {
    return (
      <div className="editor">
        <Editor
          renderNode={this.renderNode}
          renderMark={this.renderMark}
          value={this.state.value}
          onChange={this.onChange}
          plugins={plugins}
          spellCheck={false}
          autoFocus={false}
          readOnly={true}
          autoCorrect={false}
        />
      </div>
    );
  }
}

const tableStyle = {
  width: '15%',
  borderCollapse: 'collapse',
  borderTop: '1px solid black'
};

const rowStyle = {
  border: 'none',
  borderBottom: '1px solid black',
  borderRight: '1px solid black'
};

const cellStyle = {
  border: '1px solid black',
  borderTop: 'none',
  borderBottom: 'none',
  padding: '.2em',
  position: 'relative'
};

const Table = ({attributes, children}) => (
  <table style={tableStyle}>
    <tbody {...attributes}>{children}</tbody>
  </table>
);

const TableRow = ({attributes, children}) => (
  <tr style={rowStyle} {...attributes}>{children}</tr>
);

const TableCell = ({attributes, children}) => (
  <td style={cellStyle} {...attributes}>
    {children}
  </td>
);


export default ActivityContainer;
